"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var Loader = {
    openUrl: function openUrl(url) {
        if (url.search("http") === 0) {} else if (url[0] != "#") {
            url = "#" + url;
        }
        var result = window.open(url);
        if (!result) {
            alert("请在浏览器设置允许弹出窗口");
        }
    },
    loadUrl: function loadUrl(url) {
        //根据url进行加载资源
        mimironUse = window.mimironUse || {};
        mimironUse.history = mimironUse.history || [];
        mimironUse.history.push(url);

        window.location.hash = url;
        if (url[0] == "#") {
            //某些版本的IE window.location.hash返回#
            url = url.substring(1, url.length);
        }
        if (!window.mimiron2.RouteConfig) {
            console.info("请先定义window.mimiron2.RouteConfig");
            return;
        }
        var RouteConfig = window.mimiron2.RouteConfig;
        for (var i in RouteConfig) {
            if (RouteConfig[i].test(url)) {
                if (i.indexOf("|") != -1) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = i.split("|")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var j = _step.value;

                            this.loadJSX(j);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"]) {
                                _iterator["return"]();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    this.loadJSX(i);
                }
                return;
            }
        }
        for (var i in RouteConfig) {
            //如果不重复一次, 有时候会找不到, 原因尚不明确.
            if (RouteConfig[i].test(url)) {
                if (i.indexOf("|")) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = i.split("|")[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var j = _step2.value;

                            this.loadJSX(j);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2["return"]) {
                                _iterator2["return"]();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else {
                    this.loadJSX(i);
                }
                return;
            }
        }
        alert("无权限访问 " + url + " .");
        console.info("url " + url + " 没有注册.");
    },
    loadJSX: function loadJSX(path) {
        //根据路径加载jsx文件
        //如果已经进行了转义, 直接加载js文件. 目前此方法有些buggy
        if (window.mimiron2.compiled) {
            path = path.replace(".jsx", ".js");
            // 这里需要约束所有jsx页面全部渲染到DOM id= page-wrapper
            $("#page-wrapper").html('<div class="la-anim-10 la-animate"></div>'); //加载动画效果
            var _scripts = document.getElementsByTagName('script');
            //先删除其他无用的jsx, 在同步加载多个jsx时, 可能有些jsx还没加载完.
            for (var i = 0; i < _scripts.length; i++) {
                if (/^text\/javascript(;|$)/.test(_scripts.item(i).type) && _scripts.item(i).src.indexOf("?only") != -1) {
                    document.body.removeChild(_scripts.item(i));
                }
            }
            var _script = document.createElement("script");
            _script.type = "text/javascript";
            _script.src = path + "?only";
            if (mimironUse.copy) {
                //document.body.appendChild(script); 将会清空mimiron2, 原因不详.
                window.mimiron2 = $.extend({}, mimironUse.copy);
            } else {
                mimironUse.copy = $.extend({}, mimiron2);
            }
            document.body.appendChild(_script);
            document.body.removeChild(_script); //mimironUse.runScripts();运行之后即可直接删除jsx标签, 否则加载base.jsx之后加载其他jsx文件会导致重复加载  
            return;
        }
        //检查jsx转义器
        if (!window.mimironUse || typeof window.mimironUse.runScripts == "undefined") {
            console.info("如需异步加载jsx文件, 请使用Mimiron2自带的browser.js文件, 或者将babel下此文件的runScripts方法暴露到window.mimironUse下");
            return;
        }
        // 这里需要约束所有jsx页面全部渲染到DOM id= page-wrapper
        $("#page-wrapper").html('<div class="la-anim-10 la-animate"></div>'); //加载动画效果
        var scripts = document.getElementsByTagName('script');
        //先删除其他无用的jsx, 在同步加载多个jsx时, 可能有些jsx还没加载完.
        for (var i = 0; i < scripts.length; i++) {
            if (/^text\/babel(;|$)/.test(scripts.item(i).type) && scripts.item(i).src.indexOf("?only") != -1) {
                document.body.removeChild(scripts.item(i));
            }
        }
        var script = document.createElement("script");
        script.type = "text/babel";
        script.src = path + "?only";
        document.body.appendChild(script);
        mimironUse.runScripts();
        document.body.removeChild(script); //mimironUse.runScripts();运行之后即可直接删除jsx标签, 否则加载base.jsx之后加载其他jsx文件会导致重复加载
    },
    goBack: function goBack(step) {
        step = step || 1;
        step++;
        var url = null;
        while (step--) {
            url = mimironUse.history.pop();
        }window.location.hash = url;
        this.loadUrl(url);
    }
};

exports["default"] = Loader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/tools/loader.js
 ** module id = 618
 ** module chunks = 0
 **/